"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class Static extends base_1.default {
    statesOnly() {
        return this.get('/get-states-only', {});
    }
    states() {
        return this.get('/get-states', {});
    }
    caseTypes() {
        return this.get('/settings/cons-case-types');
    }
}
exports.default = new Static();
